import React, { useState, useEffect } from "react";
import { Carousel, Divider } from "antd";
import Banner from "../../components/Banner";
import { en, ch } from "../../utils/content";
import axios from "../../utils/request";
import "./index.css";
import { useNavigate, useLocation } from "react-router-dom";

const ProductPage = () => {
  const location = useLocation();
  const [solutionActive, setSolutionActive] = useState(0);
  const [firstTabs, setFirstTabs] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [productActive, setProductActive] = useState<any>(0);
  const navigate = useNavigate();
  const getProducts = async (id: number) => {
    const res: any = await axios.get("/index/product", {
      params: { cId: id },
    } as any);
    if (res.code === 200) {
      setProducts(res.data.data);
    }
  };
  const { id } = location.state || {};
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/product/class");
      if (res.code === 200) {
        setFirstTabs(res.data);
        getProducts(id || res.data[0]?.id);
        if (id) {
          const index = res.data.findIndex((item: any) => item?.id === id);
          setSolutionActive(index || 0);
        }
      }
    };
    initData();
  }, [id]);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  return (
    <div className="product">
      <Banner />
      <div className="solution">
        <div className="s-container">
          <div className="sc-title">
            {firstTabs.map((item: any, index: number) => {
              return (
                <div
                  className={`sc-t-li ${
                    solutionActive === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setSolutionActive(index);
                    setProductActive(0);
                    getProducts(item.id);
                  }}
                >
                  {item.title}
                </div>
              );
            })}
          </div>
          {products?.length ? (
            <div
              className="sc-box"
              onClick={() => {
                navigate("/detail", {
                  state: {
                    url: "/index/product/detail",
                    id: products?.[productActive]?.id,
                  },
                });
              }}
            >
              <div className="sc-b-img">
                <img src={products?.[productActive]?.img} />
              </div>
              <div className="sc-b-content">
                <div className="sc-b-c-title">
                  {products?.[productActive]?.name}
                </div>
                <div className="label-li">
                  {/* <div className="left">{TXT_INFO.productIntroduce}</div> */}
                  <div className="right">
                    {products?.[productActive]?.intro}
                  </div>
                </div>
                <div className="label-li-imgs">
                  {products?.[productActive]?.imgs?.map(
                    (
                      item: string | undefined,
                      index: React.Key | null | undefined
                    ) => {
                      return (
                        <div className="label-li-img">
                          <img className="img" src={item} key={index} />
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="empty">{TXT_INFO.empty}</div>
          )}
        </div>
      </div>
      {products?.length ? (
        <div className="s-tab-box">
          <div className="s-tab">
            {products.map((item: any, index: number) => {
              return (
                <div
                  className={`s-t-li ${
                    productActive === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setProductActive(index);
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
      <div className="sc-box mini">
        {products?.length ? (
          <Carousel
            dots={{ className: "dot-css" }}
            effect="fade"
            autoplay={true}
            speed={1000}
            draggable={true}
            autoplaySpeed={5000}
            adaptiveHeight={true}
          >
            {products?.map((item: any) => {
              return (
                <div
                  className="sc-b-li"
                  onClick={() => {
                    navigate("/detail", {
                      state: {
                        url: "/index/product/detail",
                        id: item?.id,
                      },
                    });
                  }}
                >
                  <img className="sc-b-li-img" src={item.img} />
                  <div className="sc-b-li-title">{item.name}</div>
                </div>
              );
            })}
          </Carousel>
        ) : (
          <div className="empty">{TXT_INFO.empty}</div>
        )}
      </div>
    </div>
  );
};

export default ProductPage;
